import { GetSkusRes } from './entities';

export const aiadTransactionsApi = (defHttp) => ({
  // 获取商品信息
  getSkus: (): Promise<GetSkusRes[]> => {
    return defHttp.get({ url: '/aiad/transactions/goods/pod' });
  },

  // 获取活动商品信息
  getActivitySkus: (code: string): Promise<GetSkusRes[]> => {
    return defHttp.get({ url: `/aiad/transactions/goods/activities/${code}` });
  },

  // 获取活动信息
  getActivity: (code: string) => {
    return defHttp.get({ url: `/aiad/transactions/activities/${code}` });
  },

  // 获取灵豆sku价格
  getMagicBeanSkuPrice: (params: {
    skuId: string | number;
  }): Promise<{
    price: string;
  }> => {
    return defHttp.get({ url: '/aiad/transactions/mb-price', params });
  },

  // 通过订单号获取交易详情
  getTradeRightByTradeNo: (params: { tradeNo: number }) => {
    return defHttp.get({ url: '/aiad/transactions/trade-right', params });
  },
});

export const tcQrCodeApi = (defHttp) => ({
  // 获取支付需要的code
  transactionCode: (params: { skuId: string | number }) => {
    return defHttp.post({ url: '/aiad/qr-code', params });
  },

  // 支付二维码状态轮询
  getTransactionCode: (params: { code: string }) => {
    return defHttp.get({ url: '/aiad/qr-code', params });
  },
});

export const tcAlipayApi = (defHttp) => ({
  // 支付宝下单
  createOrder: (params: { tradeNo: string; returnUrl: string }) => {
    return defHttp.post({
      url: `/tc/alipay/prepay`,
      params,
    });
  },

  // 招行支付宝下单
  createOrderByCMB: (params: { tradeNo: string; buyerId: string }) => {
    return defHttp.post({
      url: `/tc/cmb-alipay/prepay`,
      params,
    });
  },

  // 获取支付宝h5用户信息
  getAliUserInfo: (params: { code: string }) => {
    return defHttp.get({
      url: `/tc/alipay/users`,
      params,
    });
  },
});

export const aiadOrderApi = (defHttp) => ({
  // 预创建订单
  createOrder: (params: { code: string; orderChannel: string }) => {
    return defHttp.post({
      url: `/aiad/order`,
      params,
    });
  },
});

export const tcWechatApi = (defHttp) => ({
  // 获取openid
  openId: (params: { code: string }) => {
    return defHttp.get({
      url: `/tc/wechat/openid`,
      params,
    });
  },

  // 微信下单
  createOrder: (params: { openId: string; tradeNo?: string }) => {
    return defHttp.post({
      url: `/tc/wechat/prepay`,
      params,
    });
  },

  // 微信H5下单
  createH5Order: (params: { tradeNo: string }) => {
    return defHttp.post({
      url: `/tc/wechat/h5prepay`,
      params,
    });
  },

  // 获取微信初始化sdk参数
  getWechatSdkInitParams: (params: { url: string }) => {
    return defHttp.get({
      url: `/tc/wechat`,
      params,
    });
  },
});
